import deliveryZipcodeService, { getDeliveryZipCookie } from "../deliveryZipcodeService";
import { DELIVERY_ZIP_TYPES } from "./constants";

export const calculateExpirationTime = (expiryTimeInMs) => {
  const expiryDate = new Date();
  try {
    expiryDate.setTime(expiryDate.getTime() + expiryTimeInMs);
    return parseInt(expiryDate.getTime() / 1000);
  } catch (e) {
    console.error("Error calculating expiry time: " + e);
  }
};

export const isValidZipCode = (deliveryZipCode) => {
  if (deliveryZipCode) {
    return /^\d{5}$/.test(deliveryZipCode.toString().trim());
  }
  return false;
};

export const isAPOFPOZipCode = (zipcode) => {
  // Handle null, undefined, and empty string inputs explicitly
  if (zipcode === null || zipcode === undefined || zipcode === '') {
    return false;
  }
  
  const apoFpoRegex = /^(340|09(0|1|2|3|4|5|6|7|8)|96(2|3|4|5|6))\d{2}(?:-\d{4})?$/;
  
  const cleanedZipCode = String(zipcode).trim();

  return apoFpoRegex.test(cleanedZipCode);
};

export const normalizeStoreId = (storeId) => {
  if (storeId?.length === 3) {
    return "0" + storeId
  }
  return storeId;
}

export const shouldUpdateZipCode = (zipcode) => {
  const currentDeliveryZipType =
    deliveryZipcodeService.getDeliveryZipcodeType()?.type;

  const hasExistingCookie = !!getDeliveryZipCookie();
  const isSkipUpdateType = [
    DELIVERY_ZIP_TYPES.USER,
    DELIVERY_ZIP_TYPES.LOGIN,
  ].includes(currentDeliveryZipType);

  return !!zipcode || !hasExistingCookie || !isSkipUpdateType;
};